"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardSdk = void 0;
var tslib_1 = require("tslib");
var bringg_dashboard_sdk_cjs2_1 = require("@bringg/dashboard-sdk/dist/bringg-dashboard-sdk-cjs2");
var types_1 = require("@bringg/types");
var lodash_1 = require("lodash");
var whatwg_url_1 = require("whatwg-url");
var DashboardSdk = (function () {
    function DashboardSdk(_a) {
        var appName = _a.appName, config = _a.config, commonRegionConfigKeys = _a.commonRegionConfigKeys, specificRegionConfigKeys = _a.specificRegionConfigKeys;
        this.config = config;
        this.commonRegionConfigKeys = commonRegionConfigKeys;
        this.specificRegionConfigKeys = specificRegionConfigKeys;
        this.initSdkConfig(appName);
    }
    DashboardSdk.prototype.init = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!window.sdkInstance) return [3, 2];
                        _a = this;
                        return [4, window.sdkInstance];
                    case 1:
                        _a._sdk = _b.sent();
                        return [3, 4];
                    case 2: return [4, this.loginFromToken()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    };
    DashboardSdk.prototype.loginWithAuthToken = function (region, authToken) {
        if (region === void 0) { region = ''; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.initWithAuthToken(region, authToken)];
                    case 1:
                        _a._sdk = _b.sent();
                        return [2];
                }
            });
        });
    };
    DashboardSdk.prototype.loginWithEmail = function (email, password, selectedMerchant, captcha) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 7]);
                        return [4, bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.initWithEmail(email, password, selectedMerchant ? selectedMerchant.uuid : null, captcha, null, selectedMerchant ? selectedMerchant.region : null)];
                    case 1:
                        response = _a.sent();
                        this._sdk = response;
                        return [2, {
                                success: true,
                                data: response
                            }];
                    case 2:
                        e_1 = _a.sent();
                        if (!e_1.reason) return [3, 6];
                        if (!(e_1.reason.name === types_1.LOGIN_ERRORS.MERCHANTS_DATA_REASON)) return [3, 5];
                        if (!(e_1.data.length === 1)) return [3, 4];
                        return [4, this.loginWithEmail(email, password, (0, lodash_1.first)(e_1.data), captcha)];
                    case 3: return [2, _a.sent()];
                    case 4: return [2, {
                            success: false,
                            data: {
                                merchants_data: e_1.data
                            }
                        }];
                    case 5:
                        if (e_1.reason.name === types_1.LOGIN_ERRORS.RECAPTCHA_REASON) {
                            return [2, {
                                    success: false,
                                    data: {
                                        recaptcha_stoken: e_1.data
                                    }
                                }];
                        }
                        _a.label = 6;
                    case 6:
                        console.warn('failed to login', e_1);
                        throw e_1;
                    case 7: return [2];
                }
            });
        });
    };
    DashboardSdk.prototype.initSdkConfig = function (appName) {
        var sdkConfig = this.config;
        bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.setEnvironment(sdkConfig === null || sdkConfig === void 0 ? void 0 : sdkConfig.environment);
        bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.setConfigurationProvider(bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.newConfigurationProvider({
            config: sdkConfig,
            clientId: appName,
            commonRegionConfigKeys: this.commonRegionConfigKeys,
            specificRegionConfigKeys: this.specificRegionConfigKeys
        }));
    };
    DashboardSdk.prototype.loginFromToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, region;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        token = this.getTokenFromUrl() || this.getTokenFromLocalStorage();
                        region = this.getRegionFromUrl() || this.getRegionFromLocalStorage() || '';
                        if (!token) {
                            console.warn('No Token Found!');
                            return [2];
                        }
                        return [4, this.loginWithAuthToken(region, token)];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    DashboardSdk.prototype.getTokenFromLocalStorage = function () {
        return localStorage.getItem('ls.auth_key') || localStorage.getItem('auth_key') || localStorage.getItem('token');
    };
    DashboardSdk.prototype.getRegionFromLocalStorage = function () {
        return localStorage.getItem('region') || localStorage.getItem('bringg-region');
    };
    DashboardSdk.prototype.getRegionFromUrl = function () {
        var urlParams = new whatwg_url_1.URLSearchParams(window.location.search);
        var region = urlParams.get('region');
        if (!region) {
            var splitHash = window.location.hash && window.location.hash.split('?');
            if (splitHash) {
                var searchQuery = (0, lodash_1.last)(splitHash);
                var queryParams = new whatwg_url_1.URLSearchParams(searchQuery);
                region = queryParams.get('region');
            }
        }
        return region;
    };
    DashboardSdk.prototype.getTokenFromUrl = function () {
        var urlParams = new whatwg_url_1.URLSearchParams(window.location.search);
        var token = urlParams.get('token');
        if (!token) {
            var splitHash = window.location.hash && window.location.hash.split('?');
            if (splitHash) {
                var searchQuery = (0, lodash_1.last)(splitHash);
                var queryParams = new whatwg_url_1.URLSearchParams(searchQuery);
                token = queryParams.get('token');
            }
        }
        return token;
    };
    DashboardSdk.prototype.destroy = function () {
        this._sdk = null;
    };
    Object.defineProperty(DashboardSdk.prototype, "sdk", {
        get: function () {
            return this._sdk;
        },
        enumerable: false,
        configurable: true
    });
    DashboardSdk.prototype.getConfig = function () {
        var _a;
        return (_a = bringg_dashboard_sdk_cjs2_1.BringgDashboardSDK.getFullConfiguration()) !== null && _a !== void 0 ? _a : this.config;
    };
    return DashboardSdk;
}());
exports.DashboardSdk = DashboardSdk;
exports.default = DashboardSdk;
//# sourceMappingURL=dashboard-sdk.js.map